import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing"; // importa BrowserTracing para tracing
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import theme from "./bioarray-theme";
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import "./i18n/i18n";

const URL =  process.env.REACT_APP_BACKEND_URL ?? ''

Sentry.init({
   dsn: process.env.REACT_APP_SENTRY_URL,
  release: process.env.REACT_APP_SENTRY_RELEASE,
  integrations: [new BrowserTracing(),
     new Sentry.Replay({
        maskAllText: false, 
     }),
  ], // integra BrowserTracing para performance
  tracesSampleRate: 1.0, // ajusta en producción para menor carga
tracePropagationTargets: [
  URL
],
 debug: true,
  sendDefaultPii: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0 
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <App />
          </Sentry.ErrorBoundary>
        </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
